import { create } from 'zustand';

const lazyMallDefaultState: LazyMallStoreState = {
    isObservedTop: false,
    navType: 'main',
    navTitle: '',
    isFooter: true,
    appBarHeight: 64,
    isBackArrow: true,
};

const useLazyMallStore = create<LazyMallStoreState & LazyMallStoreAction>()((set) => ({
    ...lazyMallDefaultState,
    action: {
        setIsObseredTop: (isObservedTop: boolean) => set(() => ({ isObservedTop })),
        setNavType: (navType) => set(() => ({ navType })),
        setNavTitle: (navTitle) => set(() => ({ navTitle })),
        setIsFooter: (isFooter) => set(() => ({ isFooter })),
        setAppBarHeight: (appBarHeight) => set(() => ({ appBarHeight })),
        setIsBackArrow: (isBackArrow) => set(() => ({ isBackArrow }))
    },
}));

export const useLazyMallIsObservedTop = () => useLazyMallStore((state) => state.isObservedTop);
export const useLazyMallNavType = () => useLazyMallStore((state) => state.navType);
export const useLazyMallNavTitle = () => useLazyMallStore((state) => state.navTitle);
export const useLazyMallIsFooter = () => useLazyMallStore((state) => state.isFooter);
export const useLazyMallAppBarHeight = () => useLazyMallStore((state) => state.appBarHeight);
export const useLazyMallAction = () => useLazyMallStore((state) => state.action);
export const useLazyMallIsBackArrow = () => useLazyMallStore((state) => state.isBackArrow )

interface LazyMallStoreState {
    isObservedTop: boolean;
    navType: 'main' | 'backArrow';
    navTitle: string;
    isFooter: boolean;
    appBarHeight: number;
    isBackArrow: boolean;
}
interface LazyMallStoreAction {
    action: {
        setIsObseredTop: (isObservedTop: boolean) => void;
        setNavType: (navType: LazyMallStoreState['navType']) => void;
        setNavTitle: (title: string) => void;
        setIsFooter: (isFooter: boolean) => void;
        setAppBarHeight: (appBarHeight: number) => void;
        setIsBackArrow: (isBackArrow: boolean)=>void
    };
}
